import { useState } from 'react';

import { onlyDigits } from '../../../utils/format';
import { requestCode } from '../../../helpers/api/claims-site-api';

import type { IRequestCodeState } from './models';
import { IDLE, INVALID_TOKEN, PENDING, REJECTED, RESOLVED } from './config';

export const DEFAULT_PASSWORD_LIFETIME = 120; // секунд
const OPERATION = 'SMS';
const ERROR_NO_MESSAGE_ID = 'Смс с кодом подтверждения не отправлена';

const initialState: IRequestCodeState = {
    status: IDLE,
    tokenCaptcha: null,
};

export const useRequestCode = () => {
    const [state, setState] = useState<IRequestCodeState>(initialState);

    const request = async (phone: string, tokenCaptcha: string | null) => {
        setState({ ...initialState, status: PENDING, tokenCaptcha });
        const data = { phoneNumber: onlyDigits(phone), operation: OPERATION };

        await requestCode(data, { tokenCaptcha })
            .then(result => {
                const { messageId, passwordLifetime } = result;

                if (!messageId) {
                    throw new Error(ERROR_NO_MESSAGE_ID);
                }
                const resultData = {
                    ...result,
                    passwordLifetime: passwordLifetime || DEFAULT_PASSWORD_LIFETIME,
                };

                setState(prevState => ({
                    ...prevState,
                    status: RESOLVED,
                    data: resultData,
                }));
            })
            .catch(error => {
                const status = error?.response?.status === 424 ? INVALID_TOKEN : REJECTED;
                setState(prevState => ({
                    ...prevState,
                    status,
                    error: error.message,
                }));
                throw error;
            });
    };

    return { state, request };
};
